import { render, staticRenderFns } from "./dot.vue?vue&type=template&id=16adeb44&scoped=true&lang=pug&"
import script from "./dot.vue?vue&type=script&lang=js&"
export * from "./dot.vue?vue&type=script&lang=js&"
import style0 from "./dot.styl?vue&type=style&index=0&id=16adeb44&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16adeb44",
  null
  
)

export default component.exports